import { Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@glplus/glpweb-dsl';
import { useTranslation } from 'react-i18next';
import { RunnerAction } from './RunnerAction';
export function ContinueOnPhone({ runId, onClose }: { runId: string | null; onClose: () => void }) {
  const { t } = useTranslation();
  return <Dialog open={!!runId} onClose={onClose} ariaLabelledBy="continue-phone-title" maxWidth="xs" fullWidth>
    <DialogTitle id="continue-phone-title">{t('approvedHome.phoneTitle')}</DialogTitle>
    <DialogContent><Typography>{t('approvedHome.phoneBody')}</Typography></DialogContent>
    <DialogActions><RunnerAction ariaLabel={t('approvedHome.phoneDetails')} buttonText={t('approvedHome.phoneDetails')} href={runId ? `/runs?run=${encodeURIComponent(runId)}` : undefined} onClick={onClose} /><RunnerAction ariaLabel={t('approvedHome.close')} buttonText={t('approvedHome.close')} onClick={onClose} /></DialogActions>
  </Dialog>;
}
